const ActionType = {
  UPDATE_NA_ID: 'UPDATE_NA_ID',
  UPDATE_CURRENT_SITUATION: 'UPDATE_CURRENT_SITUATION',
  UPDATE_PARAMS: 'UPDATE_PARAMS',
  UPDATE_TOTAL_HEADCOUNT: 'UPDATE_TOTAL_HEADCOUNT',
  UPDATE_STARTINGYEAR: 'UPDATE_STARTINGYEAR',
  UPDATE_LEASETERMINYEARS: 'UPDATE_LEASETERMINYEARS',
  UPDATE_DEFAULTGROWTH: 'UPDATE_DEFAULTGROWTH',
  UPDATE_GROWTH_CHANGE: 'UPDATE_GROWTH_CHANGE',
  UPDATE_GROWTH_HEADCOUNT: 'UPDATE_GROWTH_HEADCOUNT',
  UPDATE_WORKPLACE_STYLE_SELECTED: 'UPDATE_WORKPLACE_STYLE_SELECTED',
  UPDATE_SPACES: 'UPDATE_SPACES',
  UPDATE_CUSTOM_SPACES: 'UPDATE_CUSTOM_SPACES',
  UPDATE_LAST_STEP: 'UPDATE_LAST_STEP',
  UPDATE_SCORECARD_REACHED: 'UPDATE_SCORECARD_REACHED',
  REMOVE_CUSTOM_SPACES: 'REMOVE_CUSTOM_SPACES',
  SET_NA: 'SET_NA',
  RESET_NA: 'RESET_NA',
  UPDATE_SPACE_SETTINGS: 'UPDATE_SPACE_SETTINGS',
  ADD_SHARED_USER: 'ADD_SHARED_USER',
  REMOVE_SHARED_USER: 'REMOVE_SHARED_USER',
  SET_ANYONE_CAN_ACCESS: 'SET_ANYONE_CAN_ACCESS',
  UPDATE_RATIOS: 'UPDATE_RATIOS',
};

export default ActionType;
